// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"518":"170241c0","817":"72b1e233"}[chunkId] + ".css";
};